<template>
    <div>
        <h1>참가신청 확인</h1>
        <form @submit.prevent="checkTicket" class="js-check-ticket-form" v-if="!buyer">
            <p>이메일 주소를 입력해 주세요.</p>
            <p class="u-text-center">
                <input autofocus class="u-6/12" placeholder="email@email.com" type="email" v-model="email">
                <button class="c-btn  c-btn--primary" type="submit">확인</button>
            </p>
        </form>

        <div v-if="sale">
            <ul>
                <li v-for="ticket in tickets.filter(t => t.count)">
                    {{ ticket.name.split('/')[1] }} {{ ticket.count }}장
                </li>
                <li v-if="sale.pricing !== '기본'">할인: {{ sale.pricing }}</li>
                <li>
                    총액: {{ parseFloat(sale.amount).toLocaleString() }}원
                    <span v-if="sale.donation">(후원: {{ parseFloat(sale.donation).toLocaleString() }}원)</span>
                </li>
            </ul>

            <h2 v-if="tickets.length">입금정보</h2>

            <ul v-if="sale.completionDate">
                <li><b>참가신청·결제 완료됐습니다.</b></li>
                <li><em style="font-size: 1.05em;">접수처에 들러 이름을 말씀해주세요.</em>
                    <br>행사 당일 접수처에서 등록 절차를 거친 후 ‘출입증’을 받아야 합니다.
                </li>
            </ul>

            <ul v-if="sale.payMethod === 'buyer' && !sale.completionDate">
                <li><b>참가신청이 확인됐습니다({{ sale.date }}).</b></li>
                <li>입금예정일: {{ sale.payDue }}</li>
                <li>
                    입금계좌:
                    <span v-if="sale.bank === '국민은행'">국민은행 017001-04-089255 (백은진)</span>
                    <span v-if="sale.bank === '농협'">농협 100037-56-119794 (백은진)</span>
                </li>
                <li>입금하실 이름: {{ sale.depositor }}</li>
            </ul>

            <ul v-if="sale.payMethod === 'online' && !sale.completionDate">
                <li>온라인 결제 중 문제가 발생해 결제가 완료되지 않았습니다.</li>
                <li>{{ sale.online_result_message }}</li>
            </ul>

        </div>

    </div>
</template>

<script>
    export default {
        name: "CheckTicket",
        data() {
            return {
                email: '',
                buyer: null,
                sale: null,
                tickets: []
            }
        },
        methods: {
            checkTicket() {
                const that = this;
                axios.post('/check-ticket', {email: this.email})
                    .then(res => {

                        if (!res.data) {
                            throw '참가 신청 정보가 없습니다. 이메일 주소를 다시 확인해 주세요 😀';
                        }

                        if (!res.data.sale) {
                            throw '참가 신청 과정에서 오류가 있었습니다. 다시 신청해 주세요 😥';
                        }


                        let title = '참가신청이 확인됐습니다 😀\n아직 입금확인은 안 됐어요 😕';
                        let text = '';
                        if (res.data.sale.completionDate) {
                            title = '확인 완료';
                            text = '참가신청·결제 완료하셨습니다.';
                        }

                        swal(title, text, 'success')
                            .then(() => {
                                this.buyer = res.data;
                                this.sale = this.buyer.sale;
                                if (this.sale) {
                                    this.tickets = this.sale.tickets;
                                }
                            });
                    })
                    .catch(error => {
                        swal('문제가 있어요', error.toString(), 'error')
                            .then(() => {
                                document.querySelector('.js-check-ticket-form [type=email]').select();
                            });
                    });

            }
        },
        mounted() {
            let pageTitle = '참가신청 확인';
            document.querySelector('title').innerText = `${pageTitle} | ${marxism.title} - 마르크스주의 포럼`;

            if (window.gtag) {
                // for google analytics page tracking
                window.gtag('config', 'UA-2193909-1', {
                    'page_title': `${pageTitle} | ${this.marxism.title} - 마르크스주의 포럼`,
                    'page_path': (new URL(location.href)).pathname
                });
            }
        }

    }
</script>

<style scoped>

</style>
